<div class="map-wrapper row" *ngIf="focusLocation">
    <input type="text" id="map-search" class="form-control" *ngIf="customOptions?.enableSearch && !viewOnly" (keydown.enter)="$event.preventDefault()"
        placeholder="{{'forms.common.Search' | translate}}" autocorrect="off" autocapitalize="off"
        spellcheck="off" type="text" #search>

    <agm-map [latitude]="focusLocation.lat" [longitude]="focusLocation.long" [zoom]="zoom" [disableDefaultUI]="false"
        (mapReady)="mapReadyHandler($event)" [ngClass]="{'map-disabled': viewOnly}"
        [style.height]="customOptions && customOptions.mapHeight ? customOptions.mapHeight: '350px'">
        <agm-marker [latitude]="selectedLocation.lat" [longitude]="selectedLocation.long" [iconUrl]="iconUrl">
        </agm-marker>
    </agm-map>
</div>